import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MaterializeAction, toast } from 'angular2-materialize';
import { Subscription } from 'rxjs';
import { NgTable } from '../../coms';
import { EmployeeId, EmployeeService } from '../../services/employee.service';
import { SecurityReport, SecurityReportEmployee, SecurityReportService } from '../../services/security-report.service';
import { Utils } from '../../util';

@Component({
  selector: 'app-update-security-report',
  templateUrl: './update-security-report.component.html',
  styleUrls: ['./update-security-report.component.css']
})
export class UpdateSecurityReportComponent implements OnInit, OnDestroy {

  id: string;
  reportEmployees: SecurityReportEmployee[]  = [];

  subs: Subscription[] = [];

  form: FormGroup;
  reportEmployee: SecurityReportEmployee = {
    id: '',
    name: '',
    time: '',
  };

  pickadateParams = Utils.pickadateParams();
  pickatimeParams = Utils.pickatimeParams();

  constructor(
    private service: SecurityReportService,
    private employeeService: EmployeeService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
  ) {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');

    let sub = this.service.getSecurityReport(this.id).subscribe(report => {
      sub.unsubscribe();
      this.form.patchValue(report);
      this.selectedIds[0] = report.employeeId;
      this.reportEmployees = report.employees;
      this.reportEmployee.time = report.time;
    });

    this.subs[0] = this.employeeService.getEmployees().subscribe(employees => {
      this.employees = {};
      this.rowsRead[0] = this.rowsRead[1] = employees.map(employee => {
        employee.id = employee.id$;
        employee.name = `${employee.name} ${employee.lastName}`;
        this.employees[employee.id] = employee;
        return employee;
      });
    });
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      date: ['', Validators.required],
      time: ['', Validators.required],
    });
  }
  ngOnDestroy(){
    for(let sub of this.subs) sub.unsubscribe();
  }

  async onSubmit({ value, valid }: { value: any, valid: boolean }) {
    let securityReport: Partial<SecurityReport> = {
      employeeId: this.selectedIds[0],
      employeeName: this.employees[this.selectedIds[0]].name,
      date: value.date,
      time: value.time,
      employees: this.reportEmployees,
    };

    await this.service.updateSecurityReport(this.id, securityReport);
    this.service.windowReplace.view(this.id);
  }
  onCancel(){
    this.service.windowReplace.read();
  }

  //////////////////////////////////////////////////////////////////////////////////////////////REPORT EMPLOYEES 
  touchReportEmployee(){
    this.reportEmployee.id = this.selectedIds[1];
    this.reportEmployee.name = (this.employees[this.selectedIds[1]] || {name: ''}).name;
    for(let key in this.reportEmployee) if(!this.reportEmployee[key]) return toast('Llene todos los datos para añadir.', 2000);
    this.reportEmployees.push({...this.reportEmployee});
    this.selectedIds[1] = '';
  }
  removeReportEmployee(index: number){
    this.reportEmployees.splice(index, 1);
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  readTable: NgTable;
  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  openModalRead(index: number) {
    this.currentReadIndex = index;
    this.readTable = new NgTable({columns: this.columnsRead[index], data: this.rowsRead[index], itemsPerPage: 5, onCellClick: this.selectRead.bind(this)});
  
    //this.onChangeTable(this.config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead(data: any): any{
    this.closeModalRead();
    this.selectedIds[this.currentReadIndex] = data.row.id;
  }
  unselectRead(){
    this.closeModalRead();
    this.selectedIds[this.currentReadIndex] = '';
  }

  selectedIds: string[] = ['', ''];
  employees: {[id: string]: EmployeeId} = {};

  get readValid(){ return !!this.employees[this.selectedIds[0]] };
  currentReadIndex: number;
  rowsRead = [[], []];
  columnsRead = [
    [//employee
      { title: 'Nombre', name: 'name' },
      { title: 'Folio', name: 'internalKey', sort: 'asc' },
      { title: 'Correo electrónico', name: 'email' }
    ],
    [//employee
      { title: 'Nombre', name: 'name' },
      { title: 'Folio', name: 'internalKey', sort: 'asc' },
      { title: 'Correo electrónico', name: 'email' }
    ],
  ];

}
